var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tour_quick_actions flex flex-wrap gap-x-3 gap-y-5"
  }, [_vm.canSwap ? _c('action-button', {
    attrs: {
      "bg-color": "bg-orange-300",
      "bg-color-square": "bg-orange-100",
      "border-color": "border-transparent",
      "icon": "swap",
      "icon-color": "text-orange-600",
      "libelle": 'Intervertir les ' + (_vm.structure && _vm.structure.type === _vm.constants.TYPE_OF || _vm.$freeParticulier() || _vm.$isGuest() ? 'référentiels' : 'postes'),
      "text-color": "text-gray-900",
      "responsive": true
    },
    on: {
      "clickAction": _vm.displaySwap
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "md:relative"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
    attrs: {
      "bg-color": "bg-indigo-300",
      "bg-color-square": "bg-indigo-200",
      "border-color": "border-transparent",
      "icon": "printer",
      "icon-color": "text-indigo-600",
      "libelle": "Imprimer",
      "text-color": "text-gray-900",
      "responsive": true
    },
    on: {
      "clickAction": _vm.displayDropDownPrint
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-150",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_vm.dropDownPrintMenu ? _c('div', {
    directives: [{
      name: "clickOutside",
      rawName: "v-clickOutside",
      value: _vm.forceHide,
      expression: "forceHide"
    }],
    staticClass: "dropDownPrintMenu z-20 absolute md:left-0 top-1/6 md:top-12 mt-1 p-10 w-max ml-auto rounded-md bg-white shadow-md shadow-gray-600 text-sm font-normal"
  }, [_c('div', {
    staticClass: "flex justify-center mb-5 text-lg text-gray-600"
  }, [_c('div', {
    staticClass: "cursor-pointer",
    class: {
      'text-indigo-600': _vm.typeExport == 'neopass'
    },
    on: {
      "click": function ($event) {
        _vm.typeExport = 'neopass';
      }
    }
  }, [_vm._v("\n              Carnet de parcours\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "cursor-pointer mx-10",
    class: {
      'text-indigo-600': _vm.typeExport == 'cv'
    },
    on: {
      "click": function ($event) {
        _vm.typeExport = 'cv';
      }
    }
  }, [_vm._v("\n              CV\n            ")]), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EXPORTER) ? _c('div', {
    staticClass: "cursor-pointer",
    class: {
      'text-indigo-600': _vm.typeExport == 'fiche'
    },
    on: {
      "click": function ($event) {
        _vm.typeExport = 'fiche';
      }
    }
  }, [_vm._v("\n              Fiches de poste\n            ")]) : _vm._e(), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EXPORTER) ? _c('div', {
    staticClass: "cursor-pointer",
    class: {
      'text-indigo-600': _vm.typeExport == 'refFormation'
    },
    on: {
      "click": function ($event) {
        _vm.typeExport = 'refFormation';
      }
    }
  }, [_vm._v("\n              Référentiel de formation\n            ")]) : _vm._e()]), _vm._v(" "), _vm.typeExport == 'neopass' ? _c('div', [_c('h6', {
    staticClass: "mb-5"
  }, [_vm._v("\n              Quels modules voulez vous imprimer ?\n            ")]), _vm._v(" "), _c('div', [_c('checkbox-indigo', {
    attrs: {
      "name": "allModule",
      "libelle": "Tout",
      "value": _vm.listModulesToExport.length == _vm.listModulesPagesToExport.length,
      "force-active-in-neopass-form": true
    },
    on: {
      "input": function (newValue) {
        _vm.selectAllModuleToExport();
      }
    }
  }), _vm._v(" "), _vm._l(_vm.listModulesPagesToExport, function (mod, indexMod) {
    return _c('checkbox-indigo', {
      key: indexMod,
      staticClass: "ml-5",
      attrs: {
        "name": mod.name,
        "libelle": mod.display_name,
        "value": _vm.listModulesToExport.includes(mod.id),
        "force-active-in-neopass-form": true
      },
      on: {
        "input": function (newValue) {
          _vm.addModuleToExport(mod.id);
        }
      }
    });
  })], 2), _vm._v(" "), _vm.typeExportInProgress == '' ? _c('div', {
    staticClass: "mt-10 flex justify-center"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": "Imprimer"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.exporterNeopass(false);
      }
    }
  }) : _vm._e()], 1) : _vm.typeExportInProgress == 'neopass' ? _c('div', {
    staticClass: "mt-10 flex justify-center"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": "Ouverture en cours",
      "spinner": true
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "mt-10 flex justify-center"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "libelle": "Imprimer"
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.errorExportPdf != '' ? _c('div', {
    staticClass: "mx-auto text-sm text-pink-600 font-normal text-center mt-5 max-w-xs"
  }, [_vm._v("\n              " + _vm._s(_vm.errorExportPdf) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.typeExport == 'cv' ? _c('div', [_vm.typeExportInProgress == '' ? _c('div', {
    staticClass: "mt-5"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": 'Imprimer un CV'
    },
    on: {
      "clickAction": function ($event) {
        return _vm.exporterCV(false);
      }
    }
  }) : _vm._e()], 1) : _vm.typeExportInProgress == 'cv' ? _c('div', {
    staticClass: "mt-5"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": "Ouverture en cours",
      "spinner": true
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "mt-5"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "libelle": 'Imprimer un CV'
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.errorExportPdf != '' ? _c('div', {
    staticClass: "mx-auto text-sm text-pink-600 font-normal text-center mt-5 max-w-xs"
  }, [_vm._v("\n              " + _vm._s(_vm.errorExportPdf) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.typeExport == 'fiche' ? _c('div', [_vm.jobs.filter(function (j) {
    return Object.keys(j).length > 0;
  }).length > 0 ? _c('div', [_c('h6', {
    staticClass: "mb-5"
  }, [_vm._v("\n                Quelle fiche de poste voulez vous imprimer ?\n              ")]), _vm._v(" "), _vm._l(_vm.uniqueJobs, function (job, kjob) {
    return _c('div', {
      key: kjob
    }, [_vm.typeExportInProgress == '' ? _c('div', {
      staticClass: "mt-5"
    }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
      attrs: {
        "border-color": "border-transparent",
        "text-color": "text-white",
        "bg-color": "bg-pink-600",
        "libelle": 'Imprimer la fiche du poste ' + job.page_template.name
      },
      on: {
        "clickAction": function ($event) {
          return _vm.exporterFiche(false, job);
        }
      }
    }) : _vm._e()], 1) : _vm.typeExportInProgress == 'fiche' + job.page_template.name ? _c('div', {
      staticClass: "mt-5"
    }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
      attrs: {
        "border-color": "border-transparent",
        "text-color": "text-white",
        "bg-color": "bg-pink-600",
        "libelle": "Ouverture en cours",
        "spinner": true
      }
    }) : _vm._e()], 1) : _c('div', {
      staticClass: "mt-5"
    }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
      attrs: {
        "border-color": "border-transparent",
        "text-color": "text-white",
        "bg-color": "bg-gray-600",
        "libelle": 'Imprimer la fiche du poste ' + job.page_template.name
      }
    }) : _vm._e()], 1)]);
  }), _vm._v(" "), _vm.errorExportPdf != '' ? _c('div', {
    staticClass: "mx-auto text-sm text-pink-600 font-normal text-center mt-5 max-w-xs"
  }, [_vm._v("\n                " + _vm._s(_vm.errorExportPdf) + "\n              ")]) : _vm._e()], 2) : _c('div', {
    staticClass: "text-gray-600"
  }, [_vm._v("\n              Vous n'avez pas de poste défini dans les compétences\n              professionnelles\n            ")])]) : _vm._e(), _vm._v(" "), _vm.typeExport == 'refFormation' ? _c('div', [_vm.jobs.filter(function (j) {
    return Object.keys(j).length > 0;
  }).length > 0 ? _c('div', [_c('h6', {
    staticClass: "mb-5"
  }, [_vm._v("\n                Quelle référentiel de formation voulez vous\n                imprimer ?\n              ")]), _vm._v(" "), _vm._l(_vm.uniqueJobs, function (job, kjob) {
    return _c('div', {
      key: kjob
    }, [_vm.typeExportInProgress == '' ? _c('div', {
      staticClass: "mt-5"
    }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
      attrs: {
        "border-color": "border-transparent",
        "text-color": "text-white",
        "bg-color": "bg-pink-600",
        "libelle": 'Exporter le référentiel de formation ' + job.page_template.name
      },
      on: {
        "clickAction": function ($event) {
          return _vm.exporterRefFormation(false, job);
        }
      }
    }) : _vm._e()], 1) : _vm.typeExportInProgress == 'refFormation' + job.page_template.name ? _c('div', {
      staticClass: "mt-5"
    }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
      attrs: {
        "border-color": "border-transparent",
        "text-color": "text-white",
        "bg-color": "bg-pink-600",
        "libelle": "Export en cours",
        "spinner": true
      }
    }) : _vm._e()], 1) : _c('div', {
      staticClass: "mt-5"
    }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
      attrs: {
        "border-color": "border-transparent",
        "text-color": "text-white",
        "bg-color": "bg-gray-600",
        "libelle": 'Exporter le référentiel de formation ' + job.page_template.name
      }
    }) : _vm._e()], 1)]);
  }), _vm._v(" "), _vm.errorExportPdf != '' ? _c('div', {
    staticClass: "mx-auto text-sm text-pink-600 font-normal text-center mt-5 max-w-xs"
  }, [_vm._v("\n                " + _vm._s(_vm.errorExportPdf) + "\n              ")]) : _vm._e()], 2) : _c('div', {
    staticClass: "text-gray-600"
  }, [_vm._v("\n              Vous n'avez pas de formation défini dans les\n              compétences\n              professionnelles\n            ")])]) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "md:relative"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
    attrs: {
      "bg-color": "bg-teal-300",
      "bg-color-square": "bg-teal-100",
      "border-color": "border-transparent",
      "icon": "upload",
      "icon-color": "text-teal-600",
      "libelle": "Exporter en PDF",
      "text-color": "text-gray-900",
      "responsive": true
    },
    on: {
      "clickAction": function ($event) {
        return _vm.displayDropDownExport();
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-150",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_vm.dropDownExportMenu ? _c('div', {
    directives: [{
      name: "clickOutside",
      rawName: "v-clickOutside",
      value: _vm.forceHide,
      expression: "forceHide"
    }],
    staticClass: "dropDownExportMenu z-20 absolute -left-0 mx-6 md:mx-0 md:left-0 top-1/6 md:top-12 mt-1 p-10 w-max rounded-md bg-white shadow-md shadow-gray-600 text-sm font-normal"
  }, [_c('div', {
    staticClass: "flex justify-center mb-5 text-lg text-gray-600"
  }, [_c('div', {
    staticClass: "cursor-pointer",
    class: {
      'text-indigo-600': _vm.typeExport == 'neopass'
    },
    on: {
      "click": function ($event) {
        _vm.typeExport = 'neopass';
      }
    }
  }, [_vm._v("\n              Carnet de parcours\n            ")]), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EXPORTER) ? _c('div', {
    staticClass: "cursor-pointer",
    class: {
      'text-indigo-600': _vm.typeExport == 'refFormation'
    },
    on: {
      "click": function ($event) {
        _vm.typeExport = 'refFormation';
      }
    }
  }, [_vm._v("\n              Référentiel de formation\n            ")]) : _vm._e()]), _vm._v(" "), _vm.typeExport == 'neopass' ? _c('div', [_c('h6', {
    staticClass: "mb-5"
  }, [_vm._v("\n              Quels modules voulez vous exporter ?\n            ")]), _vm._v(" "), _c('div', [_c('checkbox-indigo', {
    attrs: {
      "name": "allModule",
      "libelle": "Tout",
      "value": _vm.listModulesToExport.length == _vm.listModulesPagesToExport.length,
      "force-active-in-neopass-form": true
    },
    on: {
      "input": function (newValue) {
        _vm.selectAllModuleToExport();
      }
    }
  }), _vm._v(" "), _vm._l(_vm.listModulesPagesToExport, function (mod, indexMod) {
    return _c('checkbox-indigo', {
      key: indexMod,
      staticClass: "ml-5",
      attrs: {
        "name": mod.name,
        "libelle": mod.display_name,
        "value": _vm.listModulesToExport.includes(mod.id),
        "force-active-in-neopass-form": true
      },
      on: {
        "input": function (newValue) {
          _vm.addModuleToExport(mod.id);
        }
      }
    });
  })], 2), _vm._v(" "), _vm.typeExportInProgress == '' ? _c('div', {
    staticClass: "mt-10 flex justify-center"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": "Exporter en PDF"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.exporterNeopass(true);
      }
    }
  }) : _vm._e()], 1) : _vm.typeExportInProgress == 'neopass' ? _c('div', {
    staticClass: "mt-10 flex justify-center"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": "Export en cours",
      "spinner": true
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "mt-10 flex justify-center"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "libelle": "Exporter en PDF"
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.errorExportPdf != '' ? _c('div', {
    staticClass: "mx-auto text-sm text-pink-600 font-normal text-center mt-5 max-w-xs"
  }, [_vm._v("\n              " + _vm._s(_vm.errorExportPdf) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.typeExport == 'cv' ? _c('div', [_vm.typeExportInProgress == '' ? _c('div', {
    staticClass: "mt-5"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": 'Exporter un CV'
    },
    on: {
      "clickAction": function ($event) {
        return _vm.exporterCV(true);
      }
    }
  }) : _vm._e()], 1) : _vm.typeExportInProgress == 'cv' ? _c('div', {
    staticClass: "mt-5"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": "Export en cours",
      "spinner": true
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "mt-5"
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "libelle": 'Exporter un CV'
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.errorExportPdf != '' ? _c('div', {
    staticClass: "mx-auto text-sm text-pink-600 font-normal text-center mt-5 max-w-xs"
  }, [_vm._v("\n              " + _vm._s(_vm.errorExportPdf) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.typeExport == 'fiche' ? _c('div', [_vm.jobs.filter(function (j) {
    return Object.keys(j).length > 0;
  }).length > 0 ? _c('div', [_c('h6', {
    staticClass: "mb-5"
  }, [_vm._v("\n                Quelle fiche de poste voulez vous exporter ?\n              ")]), _vm._v(" "), _vm._l(_vm.uniqueJobs, function (job, kjob) {
    return _c('div', {
      key: kjob
    }, [_vm.typeExportInProgress == '' ? _c('div', {
      staticClass: "mt-5"
    }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
      attrs: {
        "border-color": "border-transparent",
        "text-color": "text-white",
        "bg-color": "bg-pink-600",
        "libelle": 'Exporter la fiche du poste ' + job.page_template.name
      },
      on: {
        "clickAction": function ($event) {
          return _vm.exporterFiche(true, job);
        }
      }
    }) : _vm._e()], 1) : _vm.typeExportInProgress == 'fiche' + job.page_template.name ? _c('div', {
      staticClass: "mt-5"
    }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
      attrs: {
        "border-color": "border-transparent",
        "text-color": "text-white",
        "bg-color": "bg-pink-600",
        "libelle": "Export en cours",
        "spinner": true
      }
    }) : _vm._e()], 1) : _c('div', {
      staticClass: "mt-5"
    }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
      attrs: {
        "border-color": "border-transparent",
        "text-color": "text-white",
        "bg-color": "bg-gray-600",
        "libelle": 'Exporter la fiche du poste ' + job.page_template.name
      }
    }) : _vm._e()], 1)]);
  }), _vm._v(" "), _vm.errorExportPdf != '' ? _c('div', {
    staticClass: "mx-auto text-sm text-pink-600 font-normal text-center mt-5 max-w-xs"
  }, [_vm._v("\n                " + _vm._s(_vm.errorExportPdf) + "\n              ")]) : _vm._e()], 2) : _c('div', {
    staticClass: "text-gray-600"
  }, [_vm._v("\n              Vous n'avez pas de poste défini dans les compétences\n              professionnelles\n            ")])]) : _vm._e(), _vm._v(" "), _vm.typeExport == 'refFormation' ? _c('div', [_vm.jobs.filter(function (j) {
    return Object.keys(j).length > 0;
  }).length > 0 ? _c('div', [_c('h6', {
    staticClass: "mb-5"
  }, [_vm._v("\n                Quelle référentiel de formation voulez vous\n                exporter ?\n              ")]), _vm._v(" "), _vm._l(_vm.uniqueJobs, function (job, kjob) {
    return _c('div', {
      key: kjob
    }, [_vm.typeExportInProgress == '' ? _c('div', {
      staticClass: "mt-5"
    }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
      attrs: {
        "border-color": "border-transparent",
        "text-color": "text-white",
        "bg-color": "bg-pink-600",
        "libelle": 'Exporter le référentiel de formation ' + job.page_template.name
      },
      on: {
        "clickAction": function ($event) {
          return _vm.exporterRefFormation(true, job);
        }
      }
    }) : _vm._e()], 1) : _vm.typeExportInProgress == 'refFormation' + job.page_template.name ? _c('div', {
      staticClass: "mt-5"
    }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
      attrs: {
        "border-color": "border-transparent",
        "text-color": "text-white",
        "bg-color": "bg-pink-600",
        "libelle": "Export en cours",
        "spinner": true
      }
    }) : _vm._e()], 1) : _c('div', {
      staticClass: "mt-5"
    }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('action-button', {
      attrs: {
        "border-color": "border-transparent",
        "text-color": "text-white",
        "bg-color": "bg-gray-600",
        "libelle": 'Exporter le référentiel de formation ' + job.page_template.name
      }
    }) : _vm._e()], 1)]);
  }), _vm._v(" "), _vm.errorExportPdf != '' ? _c('div', {
    staticClass: "mx-auto text-sm text-pink-600 font-normal text-center mt-5 max-w-xs"
  }, [_vm._v("\n                " + _vm._s(_vm.errorExportPdf) + "\n              ")]) : _vm._e()], 2) : _c('div', {
    staticClass: "text-gray-600"
  }, [_vm._v("\n              Vous n'avez pas de formation défini dans les\n              compétences\n              professionnelles\n            ")])]) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_DISPLAY) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Cartoindcompperso'
      }
    }
  }, [_c('action-button', {
    attrs: {
      "bg-color": "bg-pink-300",
      "bg-color-square": "bg-pink-100",
      "border-color": "border-transparent",
      "icon": "bar-chart-2",
      "icon-color": "text-pink-600",
      "libelle": "Cartographie individuelle",
      "text-color": "text-gray-900",
      "disabled-tooltip": "pour profiter de cette fonctionnalité veuillez faire une deuxième évaluation pour les comparer",
      "responsive": true,
      "enable-action": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.moduleName == 'cv' ? _c('action-button', {
    attrs: {
      "id": "form-action-frise",
      "bg-color": "bg-orange-300",
      "bg-color-square": "bg-orange-100",
      "border-color": "border-transparent",
      "icon": "person",
      "icon-color": "text-orange-600",
      "libelle": "Frise chronologique",
      "text-color": "text-gray-900",
      "responsive": true
    },
    on: {
      "clickAction": _vm.displayFriseChronologique
    }
  }) : _vm._e(), _vm._v(" "), _vm.$can('neopass_form_historic') ? _c('action-button', {
    attrs: {
      "bg-color": "bg-gray-300",
      "bg-color-square": "bg-gray-100",
      "border-color": "border-transparent",
      "icon": "file-text",
      "icon-color": "text-gray-600",
      "libelle": "Historique",
      "text-color": "text-gray-900",
      "responsive": true
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'UserHistory',
        params: {
          user: _vm.infosPass.id_pass
        }
      }
    }
  }, [_c('action-button', {
    staticClass: "w-max ml-4 lg:ml-0",
    attrs: {
      "border-color": "border-transparent",
      "bg-color": "bg-gray-300",
      "bg-color-square": "bg-gray-100",
      "icon-color": "text-gray-600",
      "text-color": "text-gray-900",
      "icon": "file-text",
      "libelle": "Historique des mouvements",
      "responsive": true,
      "enable-action": false
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }